import DOMPurify from 'dompurify'
import type { DirectiveBinding } from 'vue'

export const sanitizedHref = {
  mounted: applyHref,
  updated: applyHref,
}

function applyHref(el: HTMLElement, binding: DirectiveBinding<string | undefined>) {
  if (!binding.value) {
    el.removeAttribute('href')

    return
  }
  el.setAttribute('href', DOMPurify.sanitize(binding.value, { ALLOWED_TAGS: [] }))
}
